import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';

@Injectable({
  providedIn: 'root',
})
export class ContractTemplateService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(
    pageNumber: number,
    pageSize: number,
    country?: string,
    state?: string,
  ) {
    let params = new HttpParams()
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize);

    if (country) params = params.set('country', country);
    if (state) params = params.set('state', state);

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl + '/api/v1/contract-templates',
      { params },
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/contract-templates/' + id,
    );
  }

  create(data: FormData) {
    return this.http.post<ApiResult>(
      this.apiBaseUrl + '/api/v1/contract-templates',
      data,
    );
  }

  update(id: string, data: FormData) {
    return this.http.put<ApiResult>(
      this.apiBaseUrl + '/api/v1/contract-templates/' + id,
      data,
    );
  }
}
